// extracted by mini-css-extract-plugin
export default {"modalContainer":"qu","fadeRight":"ru","fadeUp":"su","topShelf":"tu","newFlavorBadge":"uu","transparentText":"vu","cancelButton":"wu","invisibleLink":"xu","closeIcon":"yu","linkContainer":"zu","hed":"Au","image":"Bu"};
    if(module.hot) {
      // 1711394576147
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  